var _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 33.5234,
    y1: 0.8125,
    x2: 0.476563,
    y2: 0.812503,
    stroke: "#CCE1FF"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 33.5234,
    y1: 10.1875,
    x2: 0.476563,
    y2: 10.1875,
    stroke: "#CCE1FF"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 33.5234,
    y1: 20.2344,
    x2: 9.28906,
    y2: 20.2344,
    stroke: "#CCE1FF"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 33.5234,
    y1: 30.1875,
    x2: 5.57812,
    y2: 30.1875,
    stroke: "#CCE1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/Lines.64c26a18538d65c9b02f010ec76da2fc.svg";
export { ForwardRef as ReactComponent };